import React, { createContext, useContext, ReactNode } from 'react';
import NotificationContainer from './notification-container';
import { useNotification, NotificationHook } from '../utils/useNotification';

const NotificationContext = createContext<NotificationHook | null>(null);

interface NotificationProviderProps {
  children: ReactNode;
}

export const NotificationProvider: React.FC<NotificationProviderProps> = ({ children }) => {
  const notificationHook = useNotification();

  return (
    <NotificationContext.Provider value={notificationHook}>
      {children}
      <NotificationContainer
        notifications={notificationHook.notifications}
        onRemove={notificationHook.removeNotification}
      />
    </NotificationContext.Provider>
  );
};

export const useNotificationContext = (): NotificationHook => {
  const context = useContext(NotificationContext);
  if (!context) {
    throw new Error('useNotificationContext must be used within a NotificationProvider');
  }
  return context;
};

// 专门用于签到的 hook
export const useCheckinNotification = () => {
  const { showSuccess, showError } = useNotificationContext();

  const showCheckinSuccess = () => {
    // tell user that he got rewards in english
    showSuccess(
      'You got rewards!',
      '',
      5000
    );
  };

  const showCheckinError = (reason: string) => {
    const errorMessages: { [key: string]: string } = {
      'User rejected': '',
      'insufficient funds': '',
      'already checked in': '',
      'network': '',
    };

    let title = 'checkin failed';
    let message = reason;

    // 根据错误原因匹配更友好的提示
    for (const [key, value] of Object.entries(errorMessages)) {
      if (reason.toLowerCase().includes(key.toLowerCase())) {
        title = value.includes('cancel') ? 'checkin canceled' : 'checkin failed';
        message = value;
        break;
      }
    }

    showError(title, message, 4000);
  };

  return {
    showCheckinSuccess,
    showCheckinError,
  };
}; 